import { Component, Input, Output, OnInit, OnChanges, SimpleChanges, SimpleChange, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators, ValidatorFn } from '@angular/forms';
import { ComponentBase, Changeable } from 'common';
import {
    GroupDto, UserClass, DirectoryGroupDto, AccountType, GetDirectoryGroupsResultDto,
    getAccountTypeLabel, DirectoryGroupsDto, UserDto, GetUsersInGroupResultDto, DirectoryUserDto, GetDirectoryUsersResultDto, GetDirectoryUsersInDirectoryGroupResultDto, GetUsersInDirectoryGroupResultDto
} from 'UvExplorerServer.Dtos.TS/Auth';
import { DirectoryGroupsCache, UsersService } from 'identity';
import { MessageService } from 'base';
import { List } from '../../../DiscoveryEngine.TS/Utils';


//class DirGroupDirUsers {
//	public domainName: string;
//	public directoryId: string;
//	public directoryId_2: string;
//	public users: List<DirectoryUserDto>;
//}


@Component({
    selector: 'directory-group',
    templateUrl: './directory-group.component.html',
    styleUrls: ['./directory-group.component.scss']
})
export class DirectoryGroupComponent extends ComponentBase implements OnInit, OnChanges, Changeable {

    @Input()
    public groupType: AccountType;

    @Input()
    public domains: string[];

    @Input()
    public target: GroupDto;

    @Input()
    public create: boolean;

    public searchButtonLabel: string;
    public searchEmptyResultMessage: string;
    public syncGroupButtonLabel: string;

    public searchValue: string;
    public domain: string;
    public dirGroups: DirectoryGroupDto[];
    public dirGroupSelection: DirectoryGroupDto;
    private dirGroupDirectoryId: string;
    private dirGroupDirectoryId_2: string;
    private dirGroupDomainName: string;

    public form: UntypedFormGroup;

    public groupname: UntypedFormControl;
    public description: UntypedFormControl;
    public groupClass: UntypedFormControl;
    public active: UntypedFormControl;
    public enableUserAutoProvisioning: UntypedFormControl;
    public allowSamlSingleSignOn: UntypedFormControl;

    public entries: any[];
    private memberUsers: List<UserDto>;
    private memberUsersAdded: boolean;

    public dirUserDialogVisible: boolean;
    public dirUserDialogTarget: UserDto;
    public dirUserDialogDomains: string[];
    public dirUserDialogUsers: DirectoryUserDto[];

    //private dirGroupDirUsersCache: DirGroupDirUsers[];

    constructor(private fb: UntypedFormBuilder,
        private usersService: UsersService,
        private messageService: MessageService) {

        super();

        this.groupType = AccountType.ActiveDirectory;
        this.domains = [];
        this.create = false;

        this.searchButtonLabel = "";
        this.searchEmptyResultMessage = "";
        this.syncGroupButtonLabel = "";
        this.searchValue = "";
        this.domain = "";
        this.dirGroups = [];
        this.dirGroupSelection = undefined;
        this.dirGroupDirectoryId = "";
        this.dirGroupDirectoryId_2 = "";
        this.dirGroupDomainName = "";

        //this.dirGroupDirUsersCache = [];

        this.entries = [];
        this.memberUsers = new List<UserDto>();
        this.memberUsersAdded = false;

        this.resetDirUserDialogState();

        this.buildForm();
    }

    private resetDirUserDialogState(): void {
        this.dirUserDialogVisible = false;
        this.dirUserDialogTarget = null;
        this.dirUserDialogDomains = [];
        this.dirUserDialogUsers = [];
    }

    public get hasDirGroups(): boolean {
        return (!!this.dirGroups && this.dirGroups.length > 0);
    }

    public get hasMemberEntries(): boolean {
        return (!!this.entries && this.entries.length > 0);
    }

    public get enableSearch(): boolean {
        return (this.isSearchValueValid(this.searchValue) && !!this.domain);
    }

    public get enableAddMemberUsers(): boolean {
        return (!this.create || !!this.dirGroupSelection);
    }

    private buildForm(): void {

        let groupname = "";
        let description = "";
        let groupClass = "Regular";
        let active = false;
        let enableUserAutoProvisioning = false;
        let allowSamlSingleSignOn = false;

        this.dirGroupDirectoryId = "";
        this.dirGroupDirectoryId_2 = "";
        this.dirGroupDomainName = "";

        if (this.target) {
            groupname = this.target.Name;
            description = this.target.Description;
            groupClass = UserClass[this.target.UserClass];
            active = this.target.IsActive;
            enableUserAutoProvisioning = this.target.EnableUserAutoProvisioning;
            allowSamlSingleSignOn = this.target.AllowSamlSingleSignOn;

            this.dirGroupDirectoryId = this.target.DirectoryId;
            this.dirGroupDirectoryId_2 = this.target.DirectoryId_2;
            this.dirGroupDomainName = this.target.DirectoryDomainName;
        }

        this.groupname = new UntypedFormControl(groupname, Validators.required);
        this.description = new UntypedFormControl(description);
        this.groupClass = new UntypedFormControl(groupClass);
        this.active = new UntypedFormControl(active);
        this.enableUserAutoProvisioning = new UntypedFormControl(enableUserAutoProvisioning);
        this.allowSamlSingleSignOn = new UntypedFormControl(allowSamlSingleSignOn);

        this.form = this.fb.group({
            groupname: this.groupname,
            description: this.description,
            groupClass: this.groupClass,
            active: this.active,
            enableUserAutoProvisioning: this.enableUserAutoProvisioning,
            allowSamlSingleSignOn: this.allowSamlSingleSignOn,
        });
    }

    public ngOnInit(): void {

    }

    public ngOnChanges(changes: SimpleChanges): void {

        if (changes["domains"]) {
            if (this.domains.length > 0) {
                this.domain = this.domains[0];
            }
            else {
                this.domain = "";
            }
        }

        if (changes["groupType"]) {
            let groupTypeString = getAccountTypeLabel(this.groupType);

            this.searchButtonLabel = `Search ${groupTypeString} Groups`;
            this.searchEmptyResultMessage = `No matching groups`;
            this.syncGroupButtonLabel = `Sync Group with ${groupTypeString}`;
        }

        this.buildForm();
        this.searchValue = "";
        this.dirGroups = [];
        this.dirGroupSelection = undefined;

        this.rebuildMemberUsers();
        this.memberUsersAdded = false;
    }

    private rebuildMemberUsers(): void {
        if (this.create) {
            if (this.dirGroupSelection) {
                this.usersService.getUsersInDirectoryGroup(this.groupType, this.dirGroupSelection.DomainName,
                    this.dirGroupSelection.PermanentId, this.dirGroupSelection.EphemeralId).subscribe(

                        (result: GetUsersInDirectoryGroupResultDto) => {
                            this.memberUsers = result.Users;
                            this.rebuildEntries();
                        },
                        (error) => {
                            this.messageService.displayErrorMessage("Could not retrieve group users");
                            this.memberUsers = new List<UserDto>();
                            this.rebuildEntries();
                        });
            }
            else {
                this.memberUsers = new List<UserDto>();
                this.entries = [];
            }
        }
        else {
            if (!!this.target) {
                this.usersService.getUsersInGroup(this.target.Guid).subscribe(
                    (result: GetUsersInGroupResultDto) => {
                        this.memberUsers = result.Users;
                        this.rebuildEntries();
                    },
                    (error) => {
                        this.messageService.displayErrorMessage("Could not retrieve group users");
                        this.memberUsers = new List<UserDto>();
                        this.rebuildEntries();
                    });
            }
            else {
                this.memberUsers = new List<UserDto>();
                this.entries = [];
            }
        }
    }

    private rebuildEntries(): void {
        this.entries = [];

        this.memberUsers.ForEach((memberUser: UserDto) => {
            this.addEntry(memberUser);
        });
    }

    private addEntry(user: UserDto): void {
        let entry = {
            username: user.Username,
            firstname: user.FirstName,
            lastname: user.LastName,
            class: UserClass[user.UserClass],
            type: getAccountTypeLabel(user.AccountType),
            active: (user.IsActive ? 'Yes' : 'No'),
            tag: user
        };

        this.entries.push(entry);
    }

    public get enableApply(): boolean {
        return (this.memberUsersAdded || (this.tempChanges && this.tempChangesValid));
    }

    public get tempChanges(): boolean {
        return this.form.dirty;
    }

    public get tempChangesValid(): boolean {
        return this.form.valid;
    }

    public get invalidTempChanges(): string[] {
        let result: string[] = [];
        if (!this.form.valid) {
            result.push("Directory Group");
        }
        return result;
    }

    public applyTempChanges(): void {
        if (!!this.target && this.tempChanges && this.tempChangesValid) {
            this.getChanges(this.target);
            this.buildForm();
        }
    }

    public discardTempChanges(): void {
        this.buildForm();
    }

    private getChanges(group: GroupDto): void {
        group.Name = this.groupname.value;
        group.Description = this.description.value;
        group.UserClass = UserClass[<string>this.groupClass.value];
        group.IsActive = this.active.value;
        group.DirectoryId = this.dirGroupDirectoryId;
        group.DirectoryId_2 = this.dirGroupDirectoryId_2;
        group.DirectoryDomainName = this.dirGroupDomainName;
        group.EnableUserAutoProvisioning = this.enableUserAutoProvisioning.value;
        group.AllowSamlSingleSignOn = this.allowSamlSingleSignOn.value;
    }

    public searchForGroups(): void {
        this.messageService.startWork();
        this.usersService.getDirectoryGroups(this.groupType, this.domain, this.searchValue, "", "").subscribe(
            (result: GetDirectoryGroupsResultDto) => {
                this.dirGroups = result.Groups.Groups.ToList().ToArray();
                this.messageService.endWork();
            },
            (error) => {
                this.messageService.displayErrorMessage("Group search failed");
                this.messageService.endWork();
            });

        //if (this.usersService.dirGroupsCache.contains(this.groupType, this.domain)) {
        //	this.doGroupSearch();
        //}
        //else {
        //	this.messageService.displayInfoMessage("Retrieving group information");
        //	this.messageService.startWork();
        //	this.usersService.getDirectoryGroups(this.groupType, this.domain).subscribe(
        //		(result: GetDirectoryGroupsResultDto) => {
        //			this.usersService.dirGroupsCache.add(this.groupType, this.domain, result.Groups);
        //			this.messageService.endWork();
        //			this.doGroupSearch();
        //		},
        //		(error) => {
        //			this.messageService.displayErrorMessage("Could not retrieve group information");
        //			this.messageService.endWork();
        //		});
        //}
    }

    //private doGroupSearch(): void {
    //	let regexStr = this.searchValue.replace(".", "\.").replace("*", ".*");
    //	let regex = new RegExp(regexStr, "i");

    //	this.dirGroups = [];
    //	let allDirGroups: DirectoryGroupsDto = this.usersService.dirGroupsCache.get(this.groupType, this.domain);
    //	allDirGroups.Groups.ForEach((dg: DirectoryGroupDto) => {
    //		if (regex.test(dg.Name)) {
    //			this.dirGroups.push(dg);
    //		}
    //	});
    //}

    private isSearchValueValid(searchValue: string): boolean {
        if (!searchValue) {
            return false;
        }
        return !!searchValue.match(/^[a-zA-Z0-9\-\_\.\* ]+$/i);
    }

    public onRowSelect(): void {
        if (this.dirGroupSelection) {
            this.groupname.setValue(this.dirGroupSelection.Name);
            this.description.setValue(this.dirGroupSelection.Description);
            this.dirGroupDirectoryId = this.dirGroupSelection.PermanentId;
            this.dirGroupDirectoryId_2 = this.dirGroupSelection.EphemeralId;
            this.dirGroupDomainName = this.domain;

            this.form.markAsDirty();

            this.messageService.startWork();
            this.messageService.displayInfoMessage("Retrieving directory group");
            this.usersService.addDirectoryGroupToCache(this.groupType, this.dirGroupDomainName,
                this.dirGroupDirectoryId, this.dirGroupDirectoryId_2).subscribe(
                    (result: boolean) => {
                        this.messageService.endWork();
                        this.rebuildMemberUsers();
                    },
                    (error) => {
                        this.messageService.endWork();
                        this.messageService.displayErrorMessage("Could not retrieve directory group");
                        this.rebuildMemberUsers();
                    });
        }
    }

    public onRowUnselect(): void {
        this.groupname.setValue("");
        this.description.setValue("");
        this.dirGroupDirectoryId = "";
        this.dirGroupDirectoryId_2 = "";
        this.dirGroupDomainName = "";

        this.rebuildMemberUsers();
    }

    public syncGroup(): void {
        this.messageService.startWork();
        this.usersService.syncDirectoryGroup(this.target).subscribe(
            (dirGroup: DirectoryGroupDto) => {
                this.groupname.setValue(dirGroup.Name);
                this.description.setValue(dirGroup.Description);
                this.rebuildMemberUsers();

                this.form.markAsDirty();
                this.messageService.displayInfoMessage("Group sync succeeded");
                this.messageService.endWork();
            },
            (error) => {
                this.messageService.displayErrorMessage("Group sync failed");
                this.messageService.endWork();
            });

        //let domainName: string = this.target.DirectoryDomainName;
        //if (this.usersService.dirGroupsCache.contains(this.groupType, domainName)) {
        //	this.doGroupSync();
        //}
        //else {
        //	this.messageService.displayInfoMessage("Retrieving group information");
        //	this.messageService.startWork();
        //	this.usersService.getDirectoryGroups(this.groupType, domainName).subscribe(
        //		(result: GetDirectoryGroupsResultDto) => {
        //			this.usersService.dirGroupsCache.add(this.groupType, domainName, result.Groups);
        //			this.messageService.endWork();
        //			this.doGroupSync();
        //		},
        //		(error) => {
        //			this.messageService.displayErrorMessage("Could not retrieve group information");
        //			this.messageService.endWork();
        //		});
        //}
    }

    //private doGroupSync() {
    //	let domainName = this.target.DirectoryDomainName;
    //	let allDirGroups: DirectoryGroupsDto = this.usersService.dirGroupsCache.get(this.groupType, domainName);

    //	let groupId: string = this.target.DirectoryId;
    //	let dirGroup: DirectoryGroupDto = allDirGroups.FindGroupById(groupId);
    //	if (dirGroup) {
    //		this.groupname.setValue(dirGroup.Name);
    //		this.description.setValue(dirGroup.Description);
    //		this.form.markAsDirty();
    //		this.messageService.displayInfoMessage("Group sync succeeded");
    //	}
    //	else {
    //		this.messageService.displayInfoMessage(
    //			`The group could not be found in ${getAccountTypeLabel(this.groupType)}`);
    //	}
    //}

    public addMemberUsers(): void {
        //let cacheEntry = this.dirGroupDirUsersCache.find((e) => (e.domainName === this.dirGroupDomainName &&
        //	e.directoryId === this.dirGroupDirectoryId && e.directoryId_2 === this.dirGroupDirectoryId_2));
        //if (cacheEntry) {
        //	this.initDirUserDialogUsers(cacheEntry.users);
        //}
        //else {
        this.messageService.startWork();
        this.messageService.displayInfoMessage("Retrieving directory group members");
        this.usersService.getDirectoryUsersInDirectoryGroup(this.groupType, this.dirGroupDomainName,
            this.dirGroupDirectoryId, this.dirGroupDirectoryId_2).subscribe(
                (result: GetDirectoryUsersInDirectoryGroupResultDto) => {
                    //let newCacheEntry = new DirGroupDirUsers();
                    //newCacheEntry.domainName = this.dirGroupDomainName;
                    //newCacheEntry.directoryId = this.dirGroupDirectoryId;
                    //newCacheEntry.directoryId_2 = this.dirGroupDirectoryId_2;
                    //newCacheEntry.users = result.Users;

                    //this.dirGroupDirUsersCache.push(newCacheEntry);

                    this.initDirUserDialogUsers(result.Users);

                    this.messageService.endWork();
                },
                (error) => {
                    this.messageService.endWork();
                    this.messageService.displayErrorMessage("Could not retrieve directory group members");
                }
            );
        //	}
    }

    private initDirUserDialogUsers(dirUsers: List<DirectoryUserDto>): void {
        this.dirUserDialogUsers = [];
        dirUsers.ForEach((dirUser: DirectoryUserDto) => {
            if (!this.memberUsers.Some(user => user.DirectoryId === dirUser.PermanentId) &&
                !this.memberUsers.Some(user => user.DirectoryId_2 === dirUser.EphemeralId)) {
                this.dirUserDialogUsers.push(dirUser);
            }
        });

        this.dirUserDialogTarget = new UserDto();
        this.dirUserDialogTarget.AccountType = this.groupType;
        this.dirUserDialogVisible = true;

        if (this.create) {
            this.dirUserDialogDomains = [this.dirGroupSelection.DomainName];
        }
        else {
            this.dirUserDialogDomains = [this.target.DirectoryDomainName];
        }
    }

    public onDirUserDialogOkClicked(user: UserDto): void {
        this.memberUsers.Add(user);
        this.addEntry(user);
        this.memberUsersAdded = true;

        // Force redisplay of modified entries
        this.triggerChangeDetection();

        this.resetDirUserDialogState();
    }

    public onDirUserDialogCancelClicked(): void {
        this.resetDirUserDialogState();
    }

    private triggerChangeDetection(): void {
        this.entries = [...this.entries];
    }

}
